// Configuration and Album Data

export const correctPassword = "soy yo, luli";

export const albumPages = [
  {
    id: 1,
    type: 'cover',
    title: "Feliz Cumpleaños, Amor de mi Vida",
    subtitle: "Hoy que cumples 22 años, quiero recordarte lo especial que eres para mí",
    content: "Quiero darte un paseo por algunos momentos hermosos que hemos vivido juntos. Todos están guardados en mi corazón, junto a ti, mi Luli hermosa."
  },
  {
    id: 2,
    type: 'photo-text',
    imageUrl: "/photos/Lu1.jpeg", 
    title: "Cuando te vi y me comencé a enamorar",
    description: "SEED fue el comienzo de todo. Confío en que fue el destino el que te llevó a aplicar para participar en este programa y el que me motivó a hacer todo lo posible para conseguir un trabajo en GOROM y repetir mi experiencia. Tengo que confesarte que desde que te vi, llamaste mucho mi atención. No solo porque tu cara es muy linda y tu voz preciosa, también porque noté tu dedicación y disciplina a lo largo de todas las sesiones del programa. También debo confesar que en algunas sesiones, sacaba screenshots a tu cámara para luego poder apreciar lo bella que eres con más detenimiento. Esa conversación que iniciamos sobre tu trabajo durante el viaje, aquella otra en instagram sobre NAO y mi trabajo en robótica, ahí fue cuando comencé a enamorarme."
  },
  {
    id: 3,
    type: 'photo-text',
    imageUrl: "/photos/Lu2.jpeg", 
    title: "Esa belleza natural, esa perfección",
    description: "Mientras conversábamos día tras día, durante meses, mi admiración iba creciendo, y también lo hacía un sentimiento profundo. Me gustaba (y aún me encanta) entrar a tu perfil de instagram, revisar todas tus fotos, tus stories y llenarme de felicidad, de más y más amor por una persona que sabía que pronto iba a conocer en persona."
  },
  {
    id: 4,
    type: 'text-photo',
    imageUrl: "/photos/Lu3.jpeg",
    title: "Una mujer talentosa, llena de aspiraciones",
    description: "En el mundo, las personas suelen dejarse llevar solo por las apariencias, por lo físico. Nunca ha sido mi caso. Tu belleza llamó mi atención, pero conocer tus sueños, aspiraciones, talentos y disciplina es lo que me ha hecho enamorarme profundamente de esa mujer que ahora tengo en mis pensamientos todo el día y todos los días. Me siento la persona más afortunada del mundo, por haberte conocido, por haber conocido a la mujer de mis sueños."
  },
  {
    id: 5,
    type: 'full-photo',
    imageUrl: "/photos/Lu4.jpeg",
    title: "Una sonrisa que guardo dentro de mi corazón",
    description: "Verte feliz es una de las mayores fuentes de motivación que he tenido en mi vida. Tu sonrisa me llena de energía, me da ánimo, me da la fuerza que necesito para superar cualquier dificultad, cualquier tristeza."
  },
  {
    id: 6,
    type: 'double-photo',
    imageUrl1: "/photos/Lu5.jpeg",
    imageUrl2: "/photos/Lu6.jpeg", 
    title: "Lo más lindo de Japón, nosotros",
    description: "Verte en Japón, conocerte por fin en persona fue un antes y un después en mi vida. Fue difícil llenarme de la valentía necesaria para darte el primer beso, pero estaba decidido a hacerlo, era lo que más esperaba ese día. Desde ese primer beso, Japón se convirtió en un lugar muy romántico para mí. Viajar contigo a Shirakawa, a Nagano, a Osaka, al parque de los monitos, a MATSUMOTOOO, todo fue mágico, fue vivir una preciosa historia de amor. Hay tantas cualidades y aspectos que me fascinan de ti, algunos ni los sé describir en palabras, pero voy a hacer mi mejor intento."
  },
  {
    id: 7,
    type: 'message',
    title: "22 Cosas que me Encantan de ti, mi Luli",
    content: [
      "Tus hermosos ojos, las dos esmeraldas más preciosas del mundo.",
      "Tu voz, mi sonido favorito en todo el universo",
      "Tu sonrisa, razón de mi felicidad",
      "Tu inteligencia, incomparable",
      "Tu calidez, humildad y empatía",
      "La dedicación y disciplina que pones en todo lo que haces",
      "Tu cabello, en todos sus estilos",
      "El lunarcito al lado de tus labios",
      "Tus labios y tus ricos besitos",
      "La forma como tus ojitos me ven",
      "Tus habilidades como líder, en general todos los talentos que tienes",
      "Tus mimitos, especialmente en mi cara y cabello",
      "Tus manitas, suaves y cálidas",
      "Tus orejitas❤️",
      "Todo tu hermoso cuerpo, de pies a cabeza",
      "Los abrazos que me das, sin importar el lugar",
      "Tu acento Argentino, no me encanta, me fascina",
      "Tu familia y la relación bonita que tienes con ellos",
      "Tus sueños y aspiraciones profesionales",
      "Todas las coincidencias que hemos tenido en nuestras vidas",
      "Tus bonitas palabras, que me digas mucho que me amas",
      "Tu Queenita, la chanchita también me encanta jeje",
    ]
  },
  {
    id: 8,
    type: 'text-photo',
    imageUrl: "/photos/Lu7.jpeg",
    title: "Un álbum sin terminar, al igual que nuestro amor",
    description: "Este álbum que guardo dentro de mi corazón, donde también vives tú, no termina después de estas páginas. Seguiré construyéndolo a partir de nuestras experiencias juntos y quiero me que ayudes en este hermoso proyecto, como protagonista que eres en mi vida. ¿Recuerdas el día cuando tomamos esta foto? Estoy seguro que nunca lo olvidaremos, al igual que muchas más memorias que vamos a hacer juntos. Quiero que guardes este álbum como un regalo de cumpleaños que traciende el tiempo, que va más allá de lo físico y no vive en un servidor de internet, vive en nuestro interior. Cada vez que necesites ánimo, cada vez que sientas un poco de falta de seguridad, vuelve a leerlo, vuelve a ver nuestras fotos y recuerda lo valiosa que eres para mí. Nunca olvides todos los talentos y cualidades que tienes, nunca sientas que no puedes lograr algo que quieres hacer por el beneficio de otras personas. Estoy muy enamorado y feliz de tenerte a mi lado, mi Luli bella, gracias por todo el tiempo que hemos estado juntos."
  },
  {
    id: 9,
    type: 'final-message',
    title: "Feliz Cumpleaños, Mi Amor",
    content: "Ahora que cumples 22 años, quiero que sepas que cada día contigo es un regalo. Has traído tanto amor, risas y alegría a mi vida. Quiero que vivas este nuevo año de tu vida junto a mí, y que le sigamos añadiendo páginas a este álbum de mi corazón. Te amo más de lo que las palabras pueden expresar. ¡Feliz cumpleaños!💕"
  }
];